import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { UsersUploadService } from './users-upload.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-users-upload',
  templateUrl: './users-upload.component.html',
  styleUrls: ['./users-upload.component.scss']
})
export class UsersUploadComponent implements OnInit {
  @ViewChild('validationError') validationErrorModel!: TemplateRef<any>;
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  headers: any = [];
  roleValue: any[] = [];
  constructor(public dialog: MatDialog, private toastr: ToastrService, private importUserService: UsersUploadService) { }
  ngOnInit(): void {
    const mastersSession = sessionStorage.getItem("masters");
    if (mastersSession) {
      const parsedResponse = JSON.parse(mastersSession);
      const masters = parsedResponse;
      this.roleValue = masters.roles || [];
    }
  }

  file: File | any = null;
  uploadedFile: File | any = null;

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onFileDrop(event: any) {
    event.preventDefault();
    this.file = event.dataTransfer.files[0];
    if (event.dataTransfer && event.dataTransfer.files.length) {
      this.validateFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    // const files: FileList = event.target.files;
    this.file = event.target.files[0];
    if (input.files && input.files.length) {
      this.validateFile(input.files[0]);
    }
  }

  fileExtension: any = null;
  fileName: any = null;
  validateFile(file: File) {
    const validExtensions = ['csv', 'xlsx', 'xls'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    this.fileName = file.name
    this.fileExtension = fileExtension
    const fileSize = file.size;

    if (fileExtension && validExtensions.includes(fileExtension)) {
      // if (fileSize <= maxSizeInBytes) {
      this.uploadedFile = file;
      // } else {
      //   this.toastr.error('File size exceeds 10MB!');
      //   this.uploadedFile = null;
      //   this.file = null;
      // }
    } else {
      this.toastr.error('Invalid file type!');
      this.uploadedFile = null;
      this.file = null;
    }
  }

  validationData: any = []
  uploadFile() {
    this.validationData = [];
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      this.importUserService.bulkUpload(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          this.toastr.success(res.body.responseMessage);
          this.validationData = res.body.data;
          if (this.validationData.length > 0) {
            this.openValidations();
          }
        } else {
          this.validationData = res.body.data;
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }

  openValidations() {
    this.dialog.open(this.validationErrorModel, {
      width: '600px',
      height: '70vh'
    });
  }

  deleteFile(): void {
    this.selectedUserType = '';
    this.uploadedFile = null;
  }
  onClose() {
    this.dialog.closeAll();
  }

  //  downloadFile() {
  //     const url = this.fileLink;
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = 'FILENAME'; // Optional: specify the filename
  //     link.click();
  //   }

  emailId: any = '';
  selectedUserType: any = '';
  exportOptions: any = [{ id: 1, name: "DD User" }, { id: 2, name: "DSE User" }, { id: 3, name: "Dealer Principal" }, { id: 4, name: "ZRA Mangers" }]
  importData() {
    if (!this.selectedUserType) {
      this.toastr.error("Please select user type!")
    } else if (this.selectedUserType == 1) {
      this.uploadFileToS3();
    } else if (this.selectedUserType == 2) {
      this.uploadFileToS3();
    } else if (this.selectedUserType == 3) {
      this.uploadFileToS3();
    } else if (this.selectedUserType == 4) {
      this.uploadFile();
    }
  }

  uploadFileDD() {
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      this.importUserService.bulkUploadDD(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }

  uploadFileDSE() {
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      this.importUserService.bulkUploadDSE(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }


  signedURL: any = ''
  uploadFileToS3() {
    const emailControl = new FormControl(this.emailId, [Validators.email]);
    if (emailControl.valid) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      let request: any = {
        fileName: this.fileName,
        fileType: this.file.type,
        type: this.selectedUserType,
        email: this.emailId
      }
      this.importUserService.uploadBucket(request).subscribe({
        next: (response: any) => {
          if (response.body.responseCode == 200) {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.signedURL = response.body.data;
            this.uploadFileByUrl()
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
          }
        },
        complete: () => {

        }
      });
    } else {
      this.toastr.error('Email ID is invalid!');
    }
  }

  uploadFileByUrl() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.importUserService.uploadFileByUrl(this.signedURL, this.file).subscribe({
      next: (response: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (response.status === 200 || response.status === 204) {
          this.toastr.success('Your file is currently being uploaded. We’ll send you an email once the data import is complete.');
        } else {
          this.toastr.error(`Upload failed. Status: ${response.status}`);
        }
      },
      complete: () => {
      }
    });
  }
}
